import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_c8exsp7hmz: FaireBrandEntity = {
  token: "b_c8exsp7hmz",
  type: "brand",
  name: "shoplittleswan",
  avatarUrl:
    "https://cdn.faire.com/fastly/4eb6c4a18e2fa18bca23fce802563ac120cd6160099b7b8e6fb5a205566400fd.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/241c5bdfb29f69ee55d68658996165edbbd0bc34ec881337176844c118c41ee7.webp",
  logoUrl:
    "https://cdn.faire.com/fastly/4eb6c4a18e2fa18bca23fce802563ac120cd6160099b7b8e6fb5a205566400fd.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/241c5bdfb29f69ee55d68658996165edbbd0bc34ec881337176844c118c41ee7.webp",
  location: "Monterey Park, CA, USA",
  minimumOrderDollars: 100,
  rating: 4,
  reviewCount: 6,
  isInsider: true,
  description:
    "Little Swan is a boutique children’s clothing brand inspired by the magic of childhood and the joy of thoughtful design. We create clothing that sparks imagination, builds confidence, and brings delight to both children and parents.\n\nEach piece is crafted with care, using soft, durable fabrics, delicate stitching, and whimsical details. Our collections balance playful charm with timeless style, designed to move with children’s adventures while remaining versatile and beautiful. From everyday essentials to special-occasion outfits, every garment reflects the creativity and curiosity inherent in every child.\n\nSustainability and ethical production are at the heart of what we do. Our pieces are designed to be long-lasting, responsibly made, and full of character — helping children explore the world while supporting a better future.\n\nWhether for retailers seeking distinctive, high-quality children’s apparel, or parents looking for clothing that combines comfort, style, and care, Little Swan delivers collections full of imagination, love, and a touch of whimsy.",
  meta: {
    source: "api",
    importedAt: "2026-03-25T23:45:30.765Z",
    importedBy: "entity-db-cli",
  },
};
